import { render, staticRenderFns } from "./EmptyJournalsCollectionCard.vue?vue&type=template&id=79887cb7&"
import script from "./EmptyJournalsCollectionCard.vue?vue&type=script&lang=js&"
export * from "./EmptyJournalsCollectionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmptyDefaultText: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/EmptyDefaultText/index.vue').default})
